// extracted by mini-css-extract-plugin
module.exports = {"pintxo-tab":"Tab_pintxo-tab__yCi92","pintxo-tab__content":"Tab_pintxo-tab__content__pXulA","pintxo-tab__indicator":"Tab_pintxo-tab__indicator__ihJbW"};